const CSS_MODULES_FLAG = 'primer_react_css_modules_ga';

export { CSS_MODULES_FLAG };
